module.exports = __webpack_public_path__ + "static/media/test_graphs.3a8676c5.svg";